/**
 * 表单项
 */
export const enum FORM_ITEM {
  /**
   * 输入框
   */
  INPUT = 'input',
  /**
   * 选择框：x-select
   */
  SELECT = 'select',
  /**
   * 数字输入框
   */
  INPUT_NUMBER = 'input-number',
  /**
   * 自动补全输入框
   */
  AUTOCOMPLETE = 'autocomplete',
  /**
   * 级联选择框
   */
  CASCADER = 'cascader',
  /**
   * 多选框
   */
  CHECKBOX = 'checkbox',
  /**
   * 取色器
   */
  COLOR_PICKER = 'color-picker',
  /**
   * 日期选择器
   */
  DATE_PICKER = 'date-picker',
  /**
   * 日期时间选择器
   */
  DATETIME_PICKER = 'datetime-picker',

  /**
   * 自定义类型日期时间选择器
   */
  DATE_PICKER_CUSTOM = 'datetime-picker-custom',
  /**
   * 时间选择器
   */
  TIME_PICKER = 'time-picker',
  /**
   * 时间选择下拉框
   */
  TIME_SELECT = 'time-select',
  /**
   * 单选框
   */
  RADIO = 'radio',
  /**
   * 单选框-按钮
   */
  RADIO_BUTTON = 'radio-button',
  /**
   * 评分
   */
  RATE = 'rate',
  /**
   * 虚拟化选择器
   */
  VIRTUALIZED_SELECT = 'select-v2',
  /**
   * 滑块
   */
  SLIDER = 'slider',
  /**
   * 开关
   */
  SWITCH = 'switch',
  /**
   * 穿梭框
   */
  TRANSFER = 'transfer',
  /**
   * 上传
   */
  UPLOAD = 'upload',
  /**
   * 上传
   */
  UPLOAD_FILE = 'upload-file',
  /**
   * 选择框：el-select
   */
  EL_SELECT = 'el-select'
}